import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/tuyen-dung/thu-moi-lam-viec'
const UV = '/tuyen-dung/ung-vien'

// Lọc danh sách thư mời làm việc
export function locThuMoiLamViec(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy danh sách thư mời làm việc theo ứng viên
export function layDanhSachThuMoiLamViecTheoUngVien(candidateId: number) {
  try {
    return axiosApi.get(`${UV}/${candidateId}/thu-de-cong-viec`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết thư mời làm việc
export function layChiTietThuMoiLamViec(id: number) {
  try {
    return axiosApi.get(`${BASE}/${id}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo thư mời làm việc
export function taoThuMoiLamViec(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật thư mời làm việc
export function capNhatThuMoiLamViec(id: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${id}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa thư mời làm việc
export function xoaThuMoiLamViec(id: number) {
  try {
    return axiosApi.delete(`${BASE}/${id}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Phê duyệt thư mời làm việc
export function duyetThuMoiLamViec(id: number, params?: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/duyet`, params || {})
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Từ chối thư mời làm việc
export function tuChoiThuMoiLamViec(id: number, params?: any) {
  try {
    return axiosApi.post(`${BASE}/${id}/tu-choi`, params || {})
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Chấp nhận offer và tạo hồ sơ
export function chapNhanOfferVaTaoHoSo(jobOfferId: number) {
  try {
    return axiosApi.post(`${BASE}/${jobOfferId}/chap-nhan-va-tao-ho-so`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
